import { oc } from '@orpc/contract';
import { idParamSchema } from '../../common/schemas/id.schemas.js';
import { runDetailSchema } from '../schemas/runs.schemas.js';
export const revalidateRunContract = oc
    .route({
    method: 'POST',
    path: '/runs/{id}/revalidate',
    tags: ['Runs'],
    summary: 'Re-run the result calculation and the validity rules after a rule change',
    description: 'Never touches the measurements — it replaces the previous result and verdicts with the ones today’s rules produce.',
})
    .input(idParamSchema)
    .output(runDetailSchema);
//# sourceMappingURL=revalidate-run.contract.js.map